import axiosInstance from "./axiosInstance";


const getUserNotification = async () => {
  const response = await axiosInstance.get("notification/all");
  return response.data;
};

const getAdminNotification = async () => {
  const response = await axiosInstance.get("notification/admin/all");
  return response.data;
};

const readNotification = async (notificationId: string) => {
  const response = await axiosInstance.patch(`notification/read/${notificationId}`);
  return response.data;
};
const deleteNotification = async (notificationId: string) => {
  const response = await axiosInstance.delete(`notification/delete/${notificationId}`);
  return response.data;
};

export const notificationService = {
  getUserNotification,
  getAdminNotification,
  readNotification,
  deleteNotification
  
};
